import feedbacksService from '@/services/FeedbacksService';

const closeProcess = async (context, { processId, reasonId, reason }) => {
  return await feedbacksService.closeProcess(processId, reasonId, reason);
};

const copyProcess = async (context, data) => {
  await feedbacksService.copyProcess(data.processId, data.correlationId);
};

const createAnonymousFeedback = async (context, { email, formId }) => {
  return await feedbacksService.createAnonymousFeedback(email, formId);
};

const createFeedback = async (context, feedbackData) => {
  await feedbacksService.createFeedback(feedbackData);
};

const createPdp = async (context, employeeId) => {
  await feedbacksService.createPdp(employeeId);
};

const deleteTableItem = async (context, itemData) => {
  return await feedbacksService.deleteTableItem(itemData);
};

const exportTalkDate = async (context, processId) => {
  return await feedbacksService.exportTalkDate(processId);
};

const getFieldValue = async (context, fieldValueRequest) => {
  const { result } = await feedbacksService.getFieldValue(
    fieldValueRequest.recipientId,
    fieldValueRequest.elementData
  );

  return result;
};

const importArchive = async (context, shorthand) => {
  return await feedbacksService.importArchive(shorthand);
};

const listDevelopmentPositions = () => {
  return feedbacksService.listDevelopmentPositions();
};

const listFeedbacksAsRecipient = async (context, employeeId) => {
  return await feedbacksService.listFeedbacksAsRecipient(employeeId);
};

const listMyFeedbacks = async ({ state }) => {
  if (!state.myFeedbacks) {
    state.myFeedbacks = await feedbacksService.listFeedbacksAsRecipient();
  }

  return state.myFeedbacks;
};

const listFeedbacksAsDonor = async () => {
  return await feedbacksService.listFeedbacksAsDonor();
};

const listAllFeedbacks = async () => {
  return await feedbacksService.listAllFeedbacks();
};

const listFeedbacksFromHierarchy = async () => {
  return await feedbacksService.listFeedbacksFromHierarchy();
};

const listPdcEdc = async (context, talkroundId) => {
  return await feedbacksService.listPdcEdc(talkroundId);
};

const listProcessTypes = async (context, targetUserId) => {
  return await feedbacksService.listProcesses(targetUserId);
};

const loadAnonymousFeedback = async (
  { state },
  { feedbackId, accessToken }
) => {
  const data = await feedbacksService.loadAnonymousFeedback(
    feedbackId,
    accessToken
  );

  data.result.id = feedbackId;

  state.currentFeedbackData = data.result;

  return data;
};

const loadFeedback = async ({ state }, feedbackId) => {
  const data = await feedbacksService.loadFeedback(feedbackId);
  data.result.id = feedbackId;

  state.feedbackInProgress =
    data.result.isInProgress || data.result.isSubmitted;
  state.currentFeedbackData = data.result;
  state.ehgValues[feedbackId] = data.result.ehgValues;

  return data;
};

const loadReviewData = async (context, data) => {
  var jsonData = [];

  const reviewData = await feedbacksService.loadReviewData(
    data.feedbackId,
    data.elementName
  );

  if (reviewData.result !== '') {
    jsonData = JSON.parse(reviewData.result);
  }

  return jsonData;
};

const saveCareerData = async ({ dispatch }, careerData) => {
  dispatch('setFeedbackInProgress', careerData.feedbackId);

  return feedbacksService.saveCareerData(
    careerData.feedbackId,
    careerData.feedbackType,
    careerData.targetPosition,
    careerData.targetDate,
    careerData.formData
  );
};

const saveComment = async ({ dispatch }, itemData) => {
  if (itemData.comment !== '') {
    dispatch('setFeedbackInProgress', itemData.feedbackId);
  }

  const result = await feedbacksService.saveComment(
    itemData.feedbackId,
    itemData.elementId,
    itemData.itemId,
    itemData.comment
  );

  return result;
};

const saveMatrixItemValue = async ({ dispatch }, itemData) => {
  dispatch('setFeedbackInProgress', itemData.feedbackId);

  return await feedbacksService.saveMatrixItemValue(
    itemData.feedbackId,
    itemData.elementId,
    itemData.itemId,
    itemData.value
  );
};

const saveItemValue = async ({ dispatch }, itemData) => {
  dispatch('setFeedbackInProgress', itemData.feedbackId);

  return await feedbacksService.saveItemValue(
    itemData.feedbackId,
    itemData.elementId,
    itemData.value
  );
};

const saveTalkDate = async (context, talkdateData) => {
  return await feedbacksService.saveTalkDate(talkdateData);
};

const saveTarget = async ({ dispatch }, targetData) => {
  if (targetData.feedbackId) {
    dispatch('setFeedbackInProgress', targetData.feedbackId);
  }

  return await feedbacksService.saveTarget(targetData);
};

const saveTableItem = async ({ dispatch }, itemData) => {
  if (itemData.columnValues.length > 0) {
    dispatch('setFeedbackInProgress', itemData.feedbackId);
  }

  return await feedbacksService.saveTableItem(itemData);
};

const searchFeedbackValues = async (context, keyword) => {
  return await feedbacksService.searchFeedbackValues(keyword);
};

const setFeedbackInProgress = ({ state }, feedbackId) => {
  if (!state.feedbackInProgress) {
    feedbacksService.setFeedbackInProgress(feedbackId);
    state.feedbackInProgress = false;
  }
};

const submitFeedback = async ({ commit }, feedbackId) => {
  const result = await feedbacksService.submitFeedback(feedbackId);

  commit('clearFeedbacks');

  return result;
};

const approveFeedback = async ({ commit }, feedbackId) => {
  const result = await feedbacksService.approveFeedback(feedbackId);

  commit('clearFeedbacks');

  return result;
};

const vetoFeedback = async ({ commit }, vetoData) => {
  const result = await feedbacksService.vetoFeedback(
    vetoData.feedbackId,
    vetoData.comment
  );

  commit('clearFeedbacks');
  return result;
};

const setProcessStatus = async (context, processData) => {
  return await feedbacksService.setProcessStatus(
    processData.id,
    processData.statusId
  );
};

const setProcessForm = async (context, processData) => {
  return await feedbacksService.setProcessForm(
    processData.id,
    processData.feedbacks[0].formId
  );
};

const getTargets = async (context, userId) => {
  return await feedbacksService.getTargets(userId);
};

const deleteTarget = async (context, targetId) => {
  return await feedbacksService.deleteTarget(targetId);
};

export default {
  approveFeedback,
  closeProcess,
  copyProcess,
  createAnonymousFeedback,
  createFeedback,
  createPdp,
  deleteTableItem,
  exportTalkDate,
  getFieldValue,
  importArchive,
  listAllFeedbacks,
  listDevelopmentPositions,
  listFeedbacksAsDonor,
  listFeedbacksAsRecipient,
  listFeedbacksFromHierarchy,
  listMyFeedbacks,
  listPdcEdc,
  listProcessTypes,
  loadAnonymousFeedback,
  loadFeedback,
  loadReviewData,
  saveCareerData,
  saveComment,
  saveItemValue,
  saveMatrixItemValue,
  saveTableItem,
  saveTalkDate,
  saveTarget,
  searchFeedbackValues,
  setFeedbackInProgress,
  submitFeedback,
  vetoFeedback,
  setProcessStatus,
  setProcessForm,
  getTargets,
  deleteTarget
};
